import {
    CONTACT_TYPES_FRONT
} from '@interlayer/js/app/components/main/MarketingPreferences/constants';

export enum PreferencesProducts {
    BINGO = 'bingo',
    CASINO = 'casino'
}

export type TPreferencesFields = 'selectAll'
    | `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.email}`
    | `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.SMS}`
    | `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.phone}`
    | `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.directMail}`
    | `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.email}`
    | `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.SMS}`
    | `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.phone}`
    | `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.directMail}`
